import { render, staticRenderFns } from "./NewSignature.vue?vue&type=template&id=8dd1f45c&scoped=true&"
import script from "./NewSignature.vue?vue&type=script&lang=js&"
export * from "./NewSignature.vue?vue&type=script&lang=js&"
import style0 from "./NewSignature.vue?vue&type=style&index=0&id=8dd1f45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd1f45c",
  null
  
)

export default component.exports